<style scoped lang="scss">
  .address{
    background: #F9F9F9;
    padding:15px 20px;
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
  }
  @media screen and (max-width: 640px){
    .address{
      display: block!important;
    }
    .ad_v{
      margin-bottom: 10px;
    }
  }
</style>
<style>
@media screen and (max-width: 640px){
  .ad .el-dialog{
    width: 85% !important;
  }
}
</style>
<template>
  <div class="edit-address">
    <div class="address">
      <div class="ad_v"><span class="mr20">{{userInfo.realName}}</span><span class="mr20">{{userInfo.mobile}}</span>{{curAddress}}</div>
      <span class="edit text-primary pointer" @click="dialogAddressVisible = true"><span class="el-icon-edit"></span> 修改配送地址</span>
    </div>
    <!--编辑地址-->
    <el-dialog
      class="ad"
      title="编辑取样地址"
      :visible.sync="dialogAddressVisible"
      width="50%">
      <el-form :model="editAddress" label-width="120px">
        <el-form-item label="地址选择" prop="address">
          <el-cascader
            v-model="editAddress.address"
            :options="cities"
            ref="myCascader"
            @change="handleAddressChange"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="editAddress.detail"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAddressVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAddress">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getRegionTreeData } from '@/utils'
import { changeAddress, customerUsers } from '../services/api.index'

export default {
  name: 'qk-edit-address',
  props: {
    label: {
      type: Array
    }
  },
  data () {
    return {
      cities: [],
      dialogAddressVisible: false,
      userInfo: {},
      curAddress: '',
      editAddress: {
        address: [],
        detail: ''
      },
      addressLabel: []
    }
  },
  created() {
    this.getUserInfo()
    this.getRegionInfo()
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    async getRegionInfo() {
      const res = await getRegionTreeData()
      this.cities = res
    },
    // 获取用户信息
    async getUserInfo () {
      customerUsers().then((res) => {
        // const { provinceCode, cityCode, countyCode, detail } = data.deliveryAddress
        const address = res.data.deliveryAddress
        this.userInfo = res.data
        this.curAddress = `${address.province}${address.city}${address.county}${address.detail}`

        this.editAddress = {
          address: [address.provinceCode, address.cityCode, address.countyCode],
          detail: address.detail
        }
        this.addressLabel = [address.province, address.city]
        this.$emit('update:label', this.addressLabel)
      })
    },
    // 选择地址
    handleAddressChange () {
      this.addressLabel = this.$refs['myCascader'].getCheckedNodes()[0].pathLabels
    },
    // 确认修改地址
    confirmAddress () {
      const { addressLabel: [province, city, county] } = this
      const { address: [provinceCode, cityCode, countyCode], detail } = this.editAddress
      const params = {province, city, county, detail, provinceCode, cityCode, countyCode}
      changeAddress(params).then(() => {
        this.$message.success('修改成功')
        this.curAddress = `${province}${city}${county}${detail}`
        this.$store.dispatch('memberInfo')
      })
      this.dialogAddressVisible = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/editAddress.vue